// ==============================
// SessionList.jsx (FULL)
// ==============================

import React, { useEffect, useState } from 'react';
import { Card, CardTitle, CardBody, Button, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import useVendorBranch from '../../utils/useVendorBranch';

const SessionList = () => {
  const { user } = useSelector((state) => state.authState);
  const navigate = useNavigate();

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [errorMessage, setErrorMessage] = useState({});
  const [sessionList, setSessionList] = useState([]);

  // ✅ Same like Weekend: start empty
  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const onHandleAdd = () => {
    navigate('/save-session');
  };

  const onHandleEdit = (id) => {
    const selected = sessionList.find((x) => x.id === id);
    navigate('/save-session', { state: { ...(selected || {}) } });
  };

  const GetSessionList = async () => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const res = await apiService.get(
        `api/SessionMaster/GetAllSession?vendorId=${vendorId}&branchId=${branchId}`,
      );

      if (res?.status === true) {
        setSessionList(res.data || []);
      } else {
        alert(res?.message || 'Failed');
      }
    } catch (e) {
      console.error(e);
      alert('Something went wrong');
    }
  };

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });

    if (canLoad) {
      GetSessionList();
    }
  }, [selectionData.vendor_id, selectionData.branch_id]);

  return (
    <>
      <div className='text-right mb-2'>
        <Button color='primary' onClick={onHandleAdd}>
          <i className='bi bi-plus-circle' /> Add Session
        </Button>
      </div>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='p-3 mb-0'>
          <i className='bi bi-calendar2-range mr-2' /> Session Master
        </CardTitle>

        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Edit</th>
                <th>Session Name</th>
                <th>Start Year</th>
                <th>End Year</th>
              </tr>
            </thead>
            <tbody>
              {sessionList.length > 0 ? (
                sessionList.map((x, i) => (
                  <tr key={x.id}>
                    <td>{i + 1}</td>
                    <td>
                      <i
                        className='bi bi-pencil text-primary'
                        style={{ cursor: 'pointer' }}
                        onClick={() => onHandleEdit(x.id)}
                      />
                    </td>
                    <td>{x.session_name}</td>
                    <td>{x.session_start_yr}</td>
                    <td>{x.session_end_yr}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan='5' className='text-center'>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default SessionList;
